<template>
  <ul class="filter">
    <li v-for="filter in filters" :key="filter.value">
      <span data-cy="page-filter" @click="() => onClick(filter.value)"
            :class="selectedFilter === filter.value ? 'active' : ''"
      >{{ filter.name }}</span>
    </li>
  </ul>
</template>
<script>

export default {
  name: 'AbstractFilters',
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    onClick: {
      type: Function,
      default: () => {
      }
    },
    selectedFilter: {
      type: String,
      default: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.filter {
  display: flex;
  flex-direction: row;
  list-style: none;
  justify-content: center;
  margin: 0;

  @media (max-width: $medium) {
    display: -webkit-box;
    min-height: 50px;
    padding-left: 5px;
    overflow-x: scroll;
    overflow-y: hidden;
    justify-content: space-around;

  }

  li {
    margin-right: 2rem;

    @media (max-width: $medium) {
        min-width: 20vw;
        margin-left: auto;
        margin-right: auto;
    }
  }

  span {
    color: $black-color;
    text-decoration: none;
    cursor: pointer;

    @media (max-width: $small) {
      margin-right: 1rem;
      display: grid;
      margin-left: 1rem;
    }

    &:hover {
      color: $primary-color;
    }

    &.active {
      font-weight: 600;
      color: $primary-color;
    }
  }
}
</style>
